import { CHANGE_FIELD_COMPETITORS } from "../constants";

// competitors
export const changeFieldCompetitors = (name, rootDomain) => ({
  type: CHANGE_FIELD_COMPETITORS,
  payload: { name, rootDomain },
});
